export default function Skeleton({
  className = '',
  width,
  height,
  radius = 'md',
  showLogo = false,
  logoSize = 56,
  logoClassName = '',
  style,
  ...props
}) {
  const sizeStyle = { ...style };
  if (width != null) sizeStyle.width = typeof width === 'number' ? `${width}px` : width;
  if (height != null) sizeStyle.height = typeof height === 'number' ? `${height}px` : height;

  const radiusClass =
    radius === 'none'
      ? 'rounded-none'
      : radius === 'sm'
      ? 'rounded-sm'
      : radius === 'lg'
      ? 'rounded-lg'
      : radius === 'xl'
      ? 'rounded-xl'
      : radius === '2xl'
      ? 'rounded-2xl'
      : radius === 'full'
      ? 'rounded-full'
      : 'rounded-md';

  return (
    <div
      aria-hidden="true"
      className={`relative overflow-hidden animate-pulse bg-[var(--dash-border-strong)] dark:bg-white/10 ${radiusClass} ${className}`}
      style={sizeStyle}
      {...props}
    >
      {showLogo ? (
        <>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/logos/logo.svg"
            alt=""
            className={`pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-30 grayscale ${logoClassName}`}
            style={{
              width: typeof logoSize === 'number' ? `${logoSize}px` : logoSize,
              height: 'auto',
            }}
          />
        </>
      ) : null}
    </div>
  );
}
